
const images = (folder, lang) => {
    const listImg = []
    if (process.env.NODE_ENV === 'development') {
        for(let i = 34; i < 90; i++){
            listImg.push(`http://localhost:8081/media/${lang}/ccAlertes/cc_alertes_${i.toString().padStart(5, '0')}.jpg`)
        }
    } else {
        for(let i = 34; i < 90; i++){
            listImg.push(`https://www.dioptase.fr/media/${lang}/ccAlertes/cc_alertes_${i.toString().padStart(5, '0')}.jpg`)
        }
    }
    return listImg;
}
export default images;

///home/dioptase/documentation/resources/${lang}/ccAlertes/index.js

///Users/hugo/Desktop/documentation/resources
